import { render } from "./OrderReturnsCard.vue?vue&type=template&id=15745d5e&scoped=true"
import script from "./OrderReturnsCard.vue?vue&type=script&lang=js"
export * from "./OrderReturnsCard.vue?vue&type=script&lang=js"

import "./OrderReturnsCard.vue?vue&type=style&index=0&id=15745d5e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15745d5e"]])

export default __exports__